import request from '@/config'
import { OrganizationSchema, OrganizationSearch } from './organization.type'

/* 集团：查询(LIST) */
export const GetOrganizationListApi = (searchIpt: OrganizationSearch = { page_size: 10, current: 1, tenant_id: 1 }): Promise<IResponse> => {
    return request.post({ url: '/api/SysOrganization/GetSysOrganizationPage', data: searchIpt })
}

/* 集团：获取详细(Detail) */
export const GetOrganizationInfoApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysOrganization/GetSysOrganizationInfo', data: delParams })
}

/* 集团：创建(CREATE) */
export const CreateOrganizationApi = (createIpt: OrganizationSchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysOrganization/InsertSysOrganization', data: createIpt })
}

/* 集团：修改(Modify) */
export const ModifyOrganizationApi = (modifyIpt: OrganizationSchema): Promise<IResponse> => {
    return request.post({ url: ' /api/SysOrganization/UpdateSysOrganization', data: modifyIpt })
}

/* 集团：删除(Delete) */
export const DelOrganizationApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysOrganization/DeleteSysOrganization', data: delParams })
}

